import React, { useState } from 'react';
import './components.css';

const faqs = [
  {
    question: 'How does your trading process work?',
    answer:
      "You can bring in up to three medium-sized boxes of books, video games, unopened puzzles, and board games at a time — no appointment necessary. Just walk in during business hours. Anything we can't take can be returned to you, or donated on your behalf.",
  },
  {
    question: 'What do I get for the books I trade in?',
    answer:
      'We offer either store credit or cash for accepted items. Store credit works out to about 30% of the price we plan to sell the item for; cash is a bit less. For a book we price at $10, that usually means about $3 in store credit or around $1 in cash. Especially desirable titles may yield more.',
  },
  {
    question: 'How long does the trading process take?',
    answer:
      "Three boxes of trade usually takes about 30 minutes. Less than that if you bring fewer. During busy stretches it can take a bit longer — you're welcome to drop off and we'll call when we're done. (We just can't hold rejected items for long due to space.)",
  },
  {
    question: 'What do you take?',
    answer:
      "Books of all genres. Our software checks how desirable a title is and whether we already have copies on the shelf — so what we accept shifts with what's been moving.",
  },
];

function Coffee() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="trading-policy" id="trading">
      <div className="section-head">
        <span className="kicker">04 — Buy · Sell · Trade</span>
        <h2 className="section-title">The trading desk, explained.</h2>
        <p className="section-lede">
          A few things worth knowing before you bring in a box of books.
        </p>
      </div>

      <div className="faq-container">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className={`faq-item ${openIndex === index ? 'open' : ''}`}
          >
            <button
              className="faq-question"
              onClick={() => toggleFAQ(index)}
              aria-expanded={openIndex === index}
            >
              {faq.question}
              <span className="faq-icon" aria-hidden="true">+</span>
            </button>
            <div className="faq-answer">{faq.answer}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Coffee;
